const CUSTOM_ASSETS_BASE = "assets/images/instructions/custom";

export const PAGE_IDS = [
 "m501",
 "m502",
 "m503",
 "m504",
 "m505",
 "m506",
 "m507",
 "m508",
 "m509",
 "m510",
];

export const MISSION_FIVE_PAGE_COUNT = PAGE_IDS.length;

export const OVERLAY_SIZE_PRESETS = {
 sm: { overlayLeftPercent: 51, overlayTopPercent: 89.5 },
 md: { overlayLeftPercent: 53, overlayTopPercent: 89.5 },
 lg: { overlayLeftPercent: 57, overlayTopPercent: 89.5 },
};

// Overlay coordinates are defaults/fallbacks for the nav hint.
// When a page has a bubble, the instructions plugin anchors the nav hint to that bubble.
export const OVERLAY_BY_PAGE = {
 m501: { overlayLeftPercent: 60, overlayTopPercent: 89.5, showBackKey: false },
 m502: { overlayLeftPercent: 52, overlayTopPercent: 89.5 },
 m503: { overlayLeftPercent: 53, overlayTopPercent: 89.5 },
 m504: { overlayLeftPercent: 53, overlayTopPercent: 89.5 },
 m505: { overlayLeftPercent: 51, overlayTopPercent: 89.5 },
 m506: { overlayLeftPercent: 63, overlayTopPercent: 89.5, showBackKey: false },
 m507: { overlayLeftPercent: 51, overlayTopPercent: 89.5 },
 m508: { overlayLeftPercent: 61, overlayTopPercent: 89.5, showBackKey: false },
 m509: { overlayLeftPercent: 51, overlayTopPercent: 89.5 },
 m510: { overlayLeftPercent: 58, overlayTopPercent: 89.5, showBackKey: false },
};

export const DEFAULT_PAGE_UI = {
 showPilot: false,
};

export const PAGE_UI_BY_PAGE = {
 m501: { showPilot: true },
};

export const BUBBLE_DEFAULT_LAYOUT = {
 wrapperLeftPercent: 32.5,
 wrapperBottomPercent: 8,
 minWidthPercent: 36,
 maxWidthPercent: 52,
 fontSizeVw: 0.85,
 padding: "0.9vw 1.2vw 2.4vw 1.2vw",
 tailBottomVw: -1.5,
 tailLeftVw: -1.5,
 tailWidthVw: 9.4,
 tailHeightVw: 2.5,
};

export const PILOT_LAYOUT_ADJUSTMENTS = {
 bubbleMaxWidthPercent: 38,
 overlayLeftOffsetPercent: -4,
};

export const FELLOW_EMOTION_SOURCES = {
 "hq-happy": `${CUSTOM_ASSETS_BASE}/hq-happy.svg`,
 "hq-impressed": `${CUSTOM_ASSETS_BASE}/hq-impressed.svg`,
 "hq-neutral": `${CUSTOM_ASSETS_BASE}/hq-neutral.svg`,
 "hq-speaking": `${CUSTOM_ASSETS_BASE}/hq-speaking.svg`,
};

export const MISSION_FIVE_BACKGROUND_SRC = `${CUSTOM_ASSETS_BASE}/background.svg`;
export const MISSION_FIVE_PILOT_SRC = `${CUSTOM_ASSETS_BASE}/driver.svg`;
